import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCart } from '../components/CartContext';

const SuccessIcon = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_8676_192)">
      <path d="M31.9995 8.72727L37.3813 15.3891L45.6722 13.1782L46.1086 21.7309L54.1377 24.8145L49.4541 32L54.1377 39.1855L46.1086 42.2691L45.6722 50.8218L37.3813 48.6109L31.9995 55.2727L26.6177 48.6109L18.3268 50.8218L17.8904 42.2691L9.86133 39.1855L14.545 32L9.86133 24.8145L17.8904 21.7309L18.3268 13.1782L26.6177 15.3891L31.9995 8.72727Z" fill="black" stroke="black" stroke-miterlimit="10" />
      <path d="M21.9629 32.7273L28.1302 38.5455L42.0356 25.4545" stroke="white" stroke-width="2" stroke-miterlimit="10" />
    </g>
    <defs>
      <clipPath id="clip0_8676_192">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);


const ErrorIcon = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_8676_199)">
      <path d="M31.9993 55.2727C44.8525 55.2727 55.272 44.8532 55.272 32C55.272 19.1468 44.8525 8.72727 31.9993 8.72727C19.1461 8.72727 8.72656 19.1468 8.72656 32C8.72656 44.8532 19.1461 55.2727 31.9993 55.2727Z" fill="black" stroke="black" stroke-miterlimit="10" />
      <path d="M40.728 40.7273L23.2734 23.2727" stroke="white" stroke-width="2" stroke-miterlimit="10" />
      <path d="M23.2734 40.7273L40.728 23.2727" stroke="white" stroke-width="2" stroke-miterlimit="10" />
    </g>
    <defs>
      <clipPath id="clip0_8676_199">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PaymentSuccessPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className='mx-2'>
      <div className="container mx-auto mb-[64px]">
        <div className="max-w-2xl mx-auto text-center">
          {/* Success Icon */}
          <div className="mb-[5px] flex justify-center">
            <SuccessIcon />
          </div>

          {/* Success Message */}
          <h1 className="text-26 font-normal mb-2">
            {t('payment.success.title', 'Payment Successful')}
          </h1>

          <div>
            <p className="text-18 font-normal">
              {t('payment.success.message', 'Your order has been processed successfully.')}
            </p>
          </div>

          <div className="space-y-2">
            <button
              onClick={() => navigate('/')}
              className="w-full py-3 bg-black text-white font-normal text-14 mt-4"
            >
              {t('payment.success.returnHome', 'Return to Homepage')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export const PaymentFailedPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { openCart } = useCart();

  return (
    <div className='mx-2'>
      <div className="container mx-auto mb-[64px]">
        <div className="max-w-2xl mx-auto text-center">
          {/* Error Icon */}
          <div className="mb-[5px] flex justify-center">
            <ErrorIcon />
          </div>

          {/* Error Message */}
          <h1 className="text-26 font-normal mb-2">
            {t('payment.failed.title', 'Payment Failed')}
          </h1>

          <div>
            <p className="text-18 font-normal">
              {t('payment.failed.message', 'There was an issue processing your payment.')}
            </p>
          </div>

          {/* Action Buttons */}
          <div className="space-y-2">
            <button
              onClick={() => openCart()}
              className="w-full py-3 bg-black text-white font-normal text-14 mt-4"
            >
              {t('payment.failed.backToCart', 'Return Home')}
            </button>
            <p className='underline font-14 text-normal cursor-pointer' onClick={() => navigate('/')}>{t('payment.failed.returnHome', 'Return Home')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};